import { render, staticRenderFns } from "./shuttle-box.vue?vue&type=template&id=13336c61&"
import script from "./shuttle-box.vue?vue&type=script&lang=js&"
export * from "./shuttle-box.vue?vue&type=script&lang=js&"
import style0 from "./shuttle-box.vue?vue&type=style&index=0&id=13336c61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports